import { cn } from "@/lib/utils";

export function CharacterLimit({ value, max }: { value: string; max: number }) {
  return (
    <div className="text-sm text-gray-500">
      <span className={cn(value.length > max && "text-red-800")}>
        {value.length}
      </span>
      /{max}
    </div>
  );
}
